var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('content-field',{attrs:{"name":"unknown","value":"Database type is unknown"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }